// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LanguageModal_wrapper__b4h3o {
  margin: 0 auto;
  display: flex;
  justify-content: center;
 
}
  


.LanguageModal_popup__cC5Cd {
  background-color: #d49000;;
  width: 85%;
  border-radius: 10px;
  padding: 35px;
  color: #161616;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  position: absolute;
  top: 20%;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
}

.LanguageModal_btnWrapper__vWQ-y {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-weight: 400;

}

.LanguageModal_text__rPAEc {
  font-weight: bold;
  margin-bottom: 20px;
}

.LanguageModal_button__-ZfAl {
  background-color: #ffc843;
  padding: 10px 20px;
  color: black;
  border-radius: 5px;
  font-weight: bold;
  border: black 2px solid;
  gap:10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
}

.LanguageModal_buttonEn__2\\+NKG{
  background-color: #ffc843;
  padding: 10px 20px 10px 10px;
  color: black;
  border-radius: 5px;
  font-weight: bold;
  border: black 2px solid;
  gap:10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
}

.LanguageModal_flag__Py\\+zy {
  width: 25px;
  height: 25px;
}

.LanguageModal_closeBtn__w1G8u {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 24px;
  cursor: pointer;
  color: black;
  
}

.LanguageModal_divFlag__niUzN {
  background-color: black;
  border-radius: 50%;
}

`, "",{"version":3,"sources":["webpack://./src/Components/LanguageModal/LanguageModal.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;;AAEzB;;;;AAIA;EACE,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;;AAElB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;;AAEd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB","sourcesContent":[".wrapper {\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n \n}\n  \n\n\n.popup {\n  background-color: #d49000;;\n  width: 85%;\n  border-radius: 10px;\n  padding: 35px;\n  color: #161616;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  position: absolute;\n  top: 20%;\n  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);\n}\n\n.btnWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  font-weight: 400;\n\n}\n\n.text {\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.button {\n  background-color: #ffc843;\n  padding: 10px 20px;\n  color: black;\n  border-radius: 5px;\n  font-weight: bold;\n  border: black 2px solid;\n  gap:10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);\n}\n\n.buttonEn{\n  background-color: #ffc843;\n  padding: 10px 20px 10px 10px;\n  color: black;\n  border-radius: 5px;\n  font-weight: bold;\n  border: black 2px solid;\n  gap:10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);\n}\n\n.flag {\n  width: 25px;\n  height: 25px;\n}\n\n.closeBtn {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  font-size: 24px;\n  cursor: pointer;\n  color: black;\n  \n}\n\n.divFlag {\n  background-color: black;\n  border-radius: 50%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `LanguageModal_wrapper__b4h3o`,
	"popup": `LanguageModal_popup__cC5Cd`,
	"btnWrapper": `LanguageModal_btnWrapper__vWQ-y`,
	"text": `LanguageModal_text__rPAEc`,
	"button": `LanguageModal_button__-ZfAl`,
	"buttonEn": `LanguageModal_buttonEn__2+NKG`,
	"flag": `LanguageModal_flag__Py+zy`,
	"closeBtn": `LanguageModal_closeBtn__w1G8u`,
	"divFlag": `LanguageModal_divFlag__niUzN`
};
export default ___CSS_LOADER_EXPORT___;
